<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
        <el-form-item label="名称" prop="username">
            <el-input placeholder="请输入名称" v-model="rule.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
            <el-input type="password" placeholder="请输入密码" v-model="rule.password" clearable @input="change()"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passvalid">
            <el-input type="password" placeholder="确认密码" v-model="rule.passvalid" clearable @input="change()"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
            <el-input type="telephone" maxlength="11" placeholder="请输入手机号" v-model="rule.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roles">
            <el-checkbox-group v-model="checkList" @change="check">
                <el-checkbox v-for="x in rolesCheck" :key="x.id" :label="x.id">{{x.name}}</el-checkbox>
              </el-checkbox-group>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="reset">重置</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import Vue from 'vue';
    export default {
        data() {
            var vaildpass = (rule, value, callback) => {
                if(this.rule.passvalid != this.rule.password) {
                    callback(new Error('两次密码不一致'));
                }else {
                    callback();
                }
            };
            var validPhone = (rule,value,callback) => {
                if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            }
            return {
                name: 'edit',
                rolesCheck:[],
                checkList:[],
                rule: {
                    id: 0,
                    username: '',
                    password: '',
                    passvalid: '',
                    mobile: '',
                    roles: []
                },
                rules: {
                    username:[
                        {required: true, message: '请输入账号', trigger: 'blur'},
                        {min:3,message:'账号长度至少为3位字符',trigger:'blur'},
                    ],
                    password:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min:3, max:32,message:'密码长度限制为3-32位',trigger:'blur'},
                    ],
                    passvalid:[
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {validator:vaildpass,trigger:'blur'},
                    ],
                    mobile: [
                        { required: true, message: '请输入手机号' },
                        {validator: validPhone,trigger:'blur'}
                    ],
                    roles: [
                        { required: true, message: '请选择角色',trigger:'blur'}
                    ],
                },
            }
        },
        mounted() {
            this.$http.get('/manage/role/listAll').then(data => {
                this.rolesCheck = data['data']['data'];
            })
        },
        created() {
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/setting/admin/index');
                }else {
                    this.rule = this.$store.state.editInfo;
                    this.rule.password = '******';
                    this.rule.passvalid = '******';
                    //角色回显
                    let temp = [];
                    for(let x of this.$store.state.editInfo.roles) {
                        temp.push(x.id);
                    }
                    this.rule.roles = temp;
                    this.checkList = temp;
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            delete this.rule.id;
                            delete this.rule.passvalid;
                            this.$http.post('/manage/user/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/setting/admin');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            delete this.rule.lastLoginTime;
                            delete this.rule.status;
                            delete this.rule.userNo;
                            if(this.rule.password && this.rule.password.trim() == '' || this.rule.password=='******') {
                                delete this.rule.password;
                            }
                            delete this.rule.passvalid;
                            this.$http.post('/manage/user/edit',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/setting/admin');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            }).catch(()=> {
                                return false;
                            })
                        }
                        
                    }
                });
            },
            reset() {
                this.$refs['forms'].resetFields();
            },
            change(){
                //潜入太深，需要刷新
                this.$forceUpdate();
            },
            check(data) {
                this.rule.roles = this.checkList;
            }
        }
    }
</script>